import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ChromeOutlinedSvg from "@ant-design/icons-svg/es/asn/ChromeOutlined";
import AntdIcon from "../components/AntdIcon";
var ChromeOutlined = function ChromeOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ChromeOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ChromeOutlined.displayName = 'ChromeOutlined';
}
export default /*#__PURE__*/React.forwardRef(ChromeOutlined);